// S7 — clip-marks API client.
//
// LiveView uses startClipMark / stopClipMark imperatively from tile
// button handlers; full list/export UI lives in a future Evidence page.
import { api } from "./client";

type Ts = { utc: string; local: string; timezone: string };

export interface ClipMark {
  id: string;
  camera_id: string;
  user_id: string;
  status: "open" | "complete" | "exported";
  label: string | null;
  notes: string | null;
  started_at: Ts | null;
  ended_at: Ts | null;
  created_at: Ts | null;
}

export async function startClipMark(
  cameraId: string,
  label?: string,
): Promise<ClipMark> {
  const { data } = await api.post<ClipMark>("/api/v1/clips/marks/start", {
    camera_id: cameraId,
    label,
  });
  return data;
}

export async function stopClipMark(markId: string): Promise<ClipMark> {
  const { data } = await api.post<ClipMark>(
    `/api/v1/clips/marks/${markId}/stop`,
  );
  return data;
}
